import {Injectable} from '@angular/core';
import {PaginatorService} from "@shared/api/services/paginator.service";
import {CareProgram} from "@shared/api/models/query/care-program.model";
import {Pagination, PaginationResponse} from "@models/pagination.model";
import {firstValueFromSafe} from "@shared/utils/empty-error";

@Injectable({
    providedIn: 'root'
})
export class CareProgramsService extends PaginatorService<CareProgram> {

    protected override get domainEntity() {
        return 'care-programs';
    };

    async listByOrganisationAndTarget(organisationId: number, target: 'patient' | 'carer'): Promise<PaginationResponse<CareProgram>> {
        const pagination = new Pagination(9999);
        pagination.filter = {
            organisationId,
            target,
        };
        return firstValueFromSafe(this.listPaginated(pagination), {data: [], pagination: undefined});
    }
}
